import {Action} from '@ngrx/store';
import {BijbEvent} from '../../../models/bijb-event';

export class GetDressCodePicturesAction implements Action {
  public static readonly type = 'GetDressCodePicturesAction';

  constructor(public bijbEvent: BijbEvent) {
  }

  public type = GetDressCodePicturesAction.type;
}
